export default {
  name: 'Sources',
  icon: 'mdi-format-textbox',
  label: 'Sources',
  priority: 101,
  isRoot() {
    return true;
  },
};
